import { HStack, VStack } from '@cbhq/cds-web/layout';
import { Tag } from '@cbhq/cds-web/tag/Tag';
import { TextBody, TextTitle1 } from '@cbhq/cds-web/typography';

import { RIGHT_RAIL_MIN_WIDTH } from './constants';
import { SpecProps } from './types';

type ProductLandingTemplateSpecsProps = {
  specs: SpecProps[];
  productTag?: 'Preview' | 'Enterprise';
};

export function ProductLandingTemplateSpecs({
  specs,
  productTag,
}: ProductLandingTemplateSpecsProps) {
  return (
    <VStack
      height="min-content"
      minWidth={RIGHT_RAIL_MIN_WIDTH}
      spacing={7}
      gap={5}
      borderColor="line"
      borderRadius="roundedLarge"
    >
      <HStack justifyContent="space-between">
        <TextTitle1 as="h2">Specs</TextTitle1>
        {productTag === 'Preview' && <Tag colorScheme="green">Preview</Tag>}
        {productTag === 'Enterprise' && <Tag colorScheme="gray">Enterprise</Tag>}
      </HStack>

      {specs.map(({ title, detail }) => {
        return (
          <HStack key={title} justifyContent="space-between">
            <TextBody as="p">{title}</TextBody>
            <TextBody as="p" color="foregroundMuted">
              {detail}
            </TextBody>
          </HStack>
        );
      })}
    </VStack>
  );
}
